{
  "me": "(moi)",
  "meta": {
    "title": "Titre",
    "description": "Description",
    "home": "Accueil",
    "auth": "Authentification",
    "register": "Inscription",
    "surferRegister": "Inscription surfeur",
    "recoverPassword": "Récupération du mot de passe",
    "resetPassword": "Réinitialisation du mot de passe",
    "verifyEmail": "Vérification de l’email",
    "userList": "Liste des utilisateurs",
    "userProfile": "Profil de l’utilisateur",
    "userEdit": "Modifier l’utilisateur",
    "companyProfile": "Profil de l’entreprise",
    "companyEdit": "Modifier l’entreprise",
    "reviews": "Avis"
  },
  "photo": "Photo de l’utilisateur",
  "name": "Prénom",
  "managerUpperCase": "Administrateur du compte entreprise",
  "recruiterUpperCase": "Recruteur",
  "connectionError": "Erreur de connexion",
  "networkError": "Connexion internet perdue. Vérifiez votre connexion et réessayez.",
  "error": "Erreur",
  "apply": "Appliquer",
  "reset": "Réinitialiser",
  "in": "dans",
  "address": "Adresse",
  "creationDate": "Date de création",
  "region": "Région",
  "all": "Tous",
  "cabinet": "Espace employeur",
  "employeeRefresh": {
    "error": "Erreur lors de la mise à jour de l’employé responsable"
  },
  "uploadFile": {
    "error": "Erreur lors du téléchargement du fichier"
  },
  "updateData": {
    "error": "Erreur lors de la mise à jour des données"
  },
  "request": {
    "error": "Erreur lors de l’envoi de la requête"
  },
  "navigation": {
    "main": "Navigation principale",
    "vacancies": "Mes offres d’emploi",
    "employees": "Utilisateurs",
    "sintiaDialog": "Dialogue avec Cynthia",
    "sintiaDialogButton": "Parlons-en",
    "faq": "FAQ",
    "reviews": "Avis",
    "openMenu": "Ouvrir le menu",
    "closeMenu": "Fermer le menu"
  },
  "sintiaDialog": {
    "chat": {
      "aiName": "Cynthia",
      "you": "Vous",
      "messageLabel": "Message à Cynthia",
      "placeholder": "Saisissez un message",
      "send": "Envoyer",
      "listen": "Écouter",
      "recommendedCandidatesDrawerTitle": "Candidats recommandés",
      "candidateDetails": "En savoir plus",
      "candidateAge": "Âge : {{age}}",
      "candidatePhone": "Numéro de téléphone",
      "candidateLoading": "Chargement du candidat",
      "candidateUnavailable": "Impossible de charger le candidat. Il n’est peut-être plus disponible.",
      "vacancyUnavailable": "Impossible de charger le poste. Il n’est peut-être plus disponible.",
      "loadError": "Impossible de charger les messages",
      "retry": "Réessayer",
      "messageFailed": "Le message n’a pas pu être envoyé",
      "waitingForReply": "En attente de la réponse de Cynthia…",
      "audioFormatHint": "Format audio: OGG, encodage OPUS *",
      "unsupportedAudioFile": "Seuls les fichiers audio OGG ou WebM avec le codec Opus peuvent être envoyés",
      "attachFile": "Joindre un fichier",
      "voiceMessage": "Message vocal",
      "openActionsMenu": "Ouvrir le menu d’actions",
      "sendMessage": "Envoyer le message",
      "actionsMenu": {
        "showOpenVacancies": "Afficher les postes ouverts",
        "startCandidateSelection": "Commencer la sélection de candidats",
        "createVacancy": "Créer un poste"
      },
      "surferUnknownCandidateChoice": {
        "text": "Pour choisir un candidat, cliquez sur le bouton « Voir » et sélectionnez le candidat de votre choix.",
        "view": "Voir"
      },
      "surferStopOrResumeSearch": {
        "text": "Malheureusement, dans cette version allégée, je ne peux créer qu'une seule proposition de travail par mois. Pour arrêter ou reprendre la recherche, connectez-vous avec votre adresse e-mail et votre mot de passe sur   https://client.cynthia.africa/ .",
        "view": "Voir"
      },
      "recordVoiceTitle": "Enregistrer un message vocal",
      "uploadAudioTitle": "Envoyer un fichier audio",
      "listenAudioTitle": "Écouter un fichier audio",
      "cancel": "Annuler",
      "finishRecordingToSend": "Terminez l’enregistrement pour envoyer le message",
      "inlineVoice": {
        "leaveSending": "L’envoi du message est déjà en cours. Quitter la conversation n’annule pas l’envoi.",
        "leaveTitle": "Quitter la conversation ?",
        "leaveDraft": "Le message vocal n’a pas été envoyé. Si vous quittez cette page, l’enregistrement sera supprimé.",
        "stay": "Rester",
        "leave": "Quitter",
        "previewFailed": "Impossible de lire l’enregistrement. Vous pouvez l’envoyer ou enregistrer à nouveau votre message.",
        "emptyRecording": "L’enregistrement est vide. Supprimez-le et enregistrez à nouveau votre message.",
        "requesting": "Autorisez l’accès au microphone dans votre navigateur",
        "finishing": "Finalisation de l’enregistrement…",
        "recording": "Enregistrement en cours · cliquez sur arrêter pour écouter",
        "review": "Écoutez puis envoyez",
        "textSaved": "Votre texte est conservé",
        "progress": "Position de lecture"
      },
      "voiceRecorder": {
        "startHint": "Commencer l’enregistrement",
        "startRecording": "Démarrer l’enregistrement",
        "stopRecording": "Arrêter l’enregistrement",
        "play": "Lecture",
        "pause": "Pause",
        "unmute": "Activer le son",
        "mute": "Couper le son",
        "loadingDuration": "Calcul de la durée de l’enregistrement",
        "delete": "Supprimer",
        "browserUnsupported": "Votre navigateur ne prend pas en charge l’enregistrement vocal.",
        "errors": {
          "unknownMime": "Impossible de déterminer le type d’enregistrement",
          "microphoneAccess": "Impossible d’accéder au microphone",
          "microphoneDenied": "Pas d’accès au microphone. Autorisez-le dans les paramètres du navigateur",
          "microphoneNotFound": "Microphone introuvable",
          "microphoneBusy": "Le microphone est utilisé par une autre application",
          "recordingFailed": "L’enregistrement a été interrompu. Réessayez",
          "audioLoadFailed": "Le fichier est en cours de traitement. Réessayez de l’écouter plus tard.",
          "audioNetworkFailed": "Impossible de charger le fichier. Vérifiez votre connexion Internet.",
          "audioDecodeFailed": "Impossible de lire le fichier."
        }
      }
    },
    "guide": {
      "openGuide": "Ouvrir le guide"
    }
  },
  "sintiaDialogGuide": {
    "title": "Guide",
    "howToDialog": {
      "title": "Comment mener le dialogue ?",
      "description": "Formulez vos questions avec vos propres mots. Aucun format particulier ni modèle n’est requis. Cynthia s’efforcera de répondre en détail à votre question et de vous aider face au problème rencontré."
    },
    "vacancyCreation": {
      "title": "Création d’une offre d’emploi",
      "description": "Au cours du dialogue, Cynthia peut créer une offre d’emploi adaptée à partir des informations que vous fournissez. L’offre créée sera disponible dans la section « Mes offres d’emploi »."
    }
  },
  "forms": {
    "registerPersonal": {
      "name": {
        "title": "Vorte prénom",
        "placeholder": ""
      },
      "surname": {
        "title": "Vorte nom",
        "placeholder": ""
      },
      "company": {
        "title": "Nom de vorte entreprise",
        "placeholder": "",
        "withoutName": "Pas de nom d’entreprise",
        "delete": "Supprimer l’entreprise"
      }
    },
    "register": {
      "formOrg": {
        "title": "Forme juridique",
        "placeholder": "Sélectionnez la forme juridique"
      }
    },
    "surferRegister": {
      "email": {
        "title": "Email",
        "description": "Cette adresse email sera votre identifiant lors de vos prochaines connexions",
        "hintControlLabel": "Informations sur l’adresse email",
        "placeholder": "yoremail@mars.com"
      },
      "phone": {
        "title": "Numero WhatsApp",
        "description": "Ce numéro WhatsApp sera utilisé pour vous informer dès que de nouveaux candidats répondant à vos critères seront identifiés",
        "hintControlLabel": "Informations sur le numéro WhatsApp",
        "placeholder": "+"
      },
      "company": {
        "title": "Nom de l’entreprise",
        "placeholder": "Saisissez le nom de l’entreprise"
      },
      "ncc": {
        "title": "NCC",
        "placeholder": "Saisissez le NCC"
      },
      "firstName": {
        "title": "Prénom",
        "placeholder": "Saisissez votre prénom"
      },
      "lastName": {
        "title": "Nom",
        "placeholder": "Saisissez votre nom"
      },
      "password": {
        "title": "Mot de passe",
        "confirmation": "Confirmation de mot de passe",
        "placeholder": "Saisissez le mot de passe"
      }
    },
    "activitySphere": {
      "title": "Secteur d’activité",
      "description": "Sélectionnez tous les secteurs d’activité de l’entreprise",
      "placeholder": "Sélectionnez",
      "nothingFound": "Aucun résultat"
    },
    "economicActivity": {
      "title": "Secteur d’activité",
      "description": "Sélectionnez tous les secteurs d’activité économique de l’entreprise",
      "placeholder": "Sélectionnez"
    },
    "employmentType": {
      "title": "Type d’emploi",
      "description": "",
      "placeholder": "Sélectionnez"
    },
    "city": {
      "title": "Ville",
      "description": "",
      "placeholder": "Sélectionnez",
      "errorMessage": "Impossible de sélectionner plusieurs régions"
    },
    "filters": {
      "from": "De",
      "to": "À",
      "currency": "Devise",
      "period": "Par",
      "surnameName": "Nom Prénom",
      "phone": "Téléphone",
      "status": "Statut",
      "role": "Rôle",
      "searchFail": "Aucun résultat trouvé",
      "subDesc": "Essayez de modifier les paramètres du filtre. Pour revenir à la liste complète, réinitialisez le filtre.",
      "vacancy": {
        "searchFail": "Aucun résultat trouvé.",
        "filteredSubDesc": "Modifiez les filtres ou réinitialisez-les pour revenir à la liste complète.",
        "empty": "La liste est vide",
        "subDesc": ""
      }
    },
    "fileUpload": {
      "fileFormat": "Fichier au format png, jpg, jpeg, webp.",
      "maxSize": "Taille maximale : 254 Ko",
      "allowedFormats": "Formats autorisés : PNG, JPG, JPEG, WEBP",
      "maxSizeError": "Taille maximale du fichier : 254 Ko",
      "uploadError": "Erreur lors du téléchargement du fichier"
    },
    "company": {
      "title": "Entreprise",
      "name": "Entrez le nom de l’entreprise",
      "form": {
        "title": "Forme juridique",
        "description": "Sélectionnez la forme juridique de l’entreprise"
      },
      "nif": {
        "title": "NCC",
        "description": "Entrez le Número de Identificação Fiscal"
      },
      "ncc": {
        "title": "NCC",
        "description": "Entrez le Numéro de Compte Contribuable",
        "placeholder": "0000000Р",
        "status": {
          "verified": "Confirmé",
          "rejected": "Non confirmé",
          "pending": "Non vérifié"
        }
      },
      "manager": {
        "title": "Responsable de l’entreprise",
        "description": "Personne de contact de l’entreprise, administre l’entreprise"
      },
      "description": {
        "title": "Description de l’entreprise",
        "description": "Décrivez brièvement l’entreprise pour les candidats"
      }
    },
    "vacancy": {
      "title": "Titre du poste",
      "vacancyPlace": "Nombre de postes vacants",
      "setupNumberEmployee": "",
      "name": {
        "title": "Titre du poste",
        "description": ""
      },
      "company": {
        "title": "Entreprise",
        "description": "Sélectionnez l’entreprise recruteuse"
      },
      "description": {
        "title": "Description de l’offre",
        "description": "Décrivez brièvement l’entreprise pour les candidats"
      }
    },
    "dateRange": {
      "from": "de",
      "to": "à"
    },
    "scheduleWork": {
      "title": "Horaires de travail",
      "description": "",
      "placeholder": "Sélectionnez"
    },
    "skill": {
      "title": "Compétences clés",
      "description": "Sélectionnez toutes les compétences nécessaires",
      "placeholder": "Sélectionnez"
    },
    "placeholders": {
      "enterName": "",
      "enterDescription": ""
    }
  },
  "loginForm": {
    "title": "Connectez-vous à votre espace employeur",
    "description": ""
  },
  "auth": {
    "verifyEmailSuccess": "Email vérifié avec succès",
    "verifyEmailError": "Erreur lors de l’envoi de la requête",
    "resetPasswordSuccess": "Mot de passe modifié avec succès",
    "recoverPasswordInfo": "Vérifiez votre boîte mail. Un lien de réinitialisation a été envoyé à l’email indiqué",
    "enterPass": "Le mot de passe doit contenir au moins 8 caractéres",
    "next": "Suivant",
    "confirmRegister": "J'accepte les Conditions générales d'uutilisation et la Politique de confidentialité",
    "userAgreement": "Contrat d'utilisation",
    "privacyPolicy": "Politique de confidentialité",
    "confirmPass": "Confirmation du mot de passe",
    "password": "Mot de passe",
    "forgotPass": "Mot de passe oublié ?",
    "login": "Se connecter",
    "logOut": "Déconnexion",
    "noAcc": "Pas de compte ?",
    "hasAccount": "Vous avez déjà un compte ?",
    "recoverPass": "Récupérer",
    "remindPass": "Vous vous souvenez du mot de passe ?",
    "resetPassword": {
      "title": "Réinitialisation du mot de passe",
      "description": "Veuillez définir un nouveau mot de passe sécurisé pour accéder à votre espace"
    },
    "register": {
      "title": "Création de compte",
      "titleButton": "Créer le compte",
      "description": "Pour commencer à recruter avec Cynthia, créez un compte",
      "descriptionPersonal": "Il ne reste plus que quelques Informations à renseigner",
      "error": "Erreur lors de l’inscription"
    },
    "surferWelcome": {
      "title": "Bienvenue dans le club !",
      "startDialog": "Commencer le dialogue"
    },
    "recoverPassword": {
      "message": "Vérifiez votre boîte mail. Un lien de réinitialisation a été envoyé à l’email indiqué",
      "forgotPass": "Mot de passe oublié ?",
      "description": "Nous enverrons un lien de réinitialisation du mot de passe à l’email indiqué",
      "title": "Se connecter",
      "back": "Retour"
    }
  },
  "company": {
    "employees": {
      "title": "Utilisateurs",
      "management": "",
      "users": "utilisateurs"
    },
    "reviews": {
      "title": "Avis",
      "empty": "Aucun avis",
      "ratingOfFive": "{{value}} sur 5",
      "hired": "A été embauché",
      "notHired": "N’a pas été embauché",
      "interviewDone": "L’entretien a eu lieu",
      "interviewNotDone": "L’entretien n’a pas eu lieu",
      "pageTitle": "Avis",
      "companyRatingSummary": "Note de l’entreprise {{value}} {{unit}}",
      "ratingLabel": "Note : {{value}}",
      "detailTitle": "Avis du candidat du {{date}}",
      "comment": "Commentaire",
      "interviewCancellationReason": "Raison de l’entretien non réalisé",
      "columns": {
        "reviewAt": "Date et heure de l’avis",
        "ratingTotal": "Note",
        "vacancy": "Offre",
        "isHired": "Embauché",
        "interviewDone": "Entretien"
      },
      "filters": {
        "createdAtFrom": "Date de création, du",
        "createdAtTo": "Date de création, au",
        "dateRangeError": "La date « au » ne peut pas être antérieure à la date « du »"
      },
      "answersLegend": {
        "yes": "Oui",
        "no": "Non"
      }
    },
    "rating": {
      "title": "Note de l’entreprise",
      "score": "{{value}} {{unit}}",
      "scoreUnits": {
        "one": "point",
        "few": "points",
        "many": "points"
      },
      "howToImprove": "Comment améliorer le niveau",
      "hint": "La note est calculée en fonction de la qualité du remplissage des offres d’emploi et des évaluations des candidats",
      "levels": {
        "none": "Aucun niveau",
        "iron": "Niveau fer",
        "bronze": "Niveau bronze",
        "silver": "Niveau argent",
        "gold": "Niveau or",
        "platinum": "Niveau platine"
      },
      "levelsShort": {
        "none": "Aucun niveau",
        "iron": "Fer",
        "bronze": "Bronze",
        "silver": "Argent",
        "gold": "Or",
        "platinum": "Platine"
      },
      "howToImproveModal": {
        "title": "Comment améliorer le niveau",
        "currentLevel": "Votre niveau actuel :",
        "currentLevelValue": "{{level}} / {{score}}",
        "nextLevelHint": {
          "before": "Pour passer au",
          "after": ", augmentez votre score de :"
        },
        "maxLevelMessage": "Vous avez atteint le niveau maximum ! Maintenez-le pour attirer les meilleurs candidats.",
        "improveTitle": "Ce qu’il faut faire pour monter de niveau:",
        "maintainTitle": "Ce qu’il faut faire pour maintenir le niveau:",
        "tips": {
          "vacancies": {
            "title": "Améliorez la description de vos offres :",
            "body": "remplissez tous les champs et fournissez une description détaillée."
          },
          "company": {
            "title": "Complétez toutes les données de l’entreprise :",
            "body": "assurez-vous que toutes les informations sont renseignées."
          },
          "interaction": {
            "title": "Améliorez la qualité des interactions avec les candidats et les collaborateurs :",
            "body": "communication, conditions de travail, accueil, rémunération et autres facteurs qui favorisent une impression positive et un avis."
          }
        }
      }
    },
    "info": {
      "description": "Description de l’entreprise",
      "edit": "Modifier",
      "company": "Nom de l’entreprise",
      "region": "Région",
      "manager": "Administrateur du compte",
      "activitySphere": "Secteur d’activité",
      "descriptionTitle": "Fiche d’entreprise",
      "city": "Ville"
    },
    "edit": {
      "personalData": "Données personnelles",
      "updateSuccess": "Entreprise mise à jour avec succès",
      "updateError": "Erreur lors de la mise à jour de l’entreprise"
    },
    "nccCandidatePick": {
      "missingMessage": "Pour sélectionner un candidat, renseignez le NCC de votre entreprise. La sélection sera disponible après sa vérification.",
      "title": "Sélection de candidat",
      "pendingMessage": "La vérification du Numéro de Compte Contribuable (NCC) de votre entreprise est en cours. Veuillez attendre la fin de la vérification pour procéder à la sélection de candidats.",
      "failedMessage": "Vous ne pouvez pas procéder à la sélection de candidats car le Numéro de Compte Contribuable (NCC) renseigné n’a pas pu être vérifié. Veuillez saisir un NCC valide ci-dessous.",
      "nccRequired": "Obligatoire",
      "close": "Fermer",
      "cancel": "Annuler",
      "save": "Enregistrer"
    },
    "delete": {
      "title": "Supprimer l’entreprise",
      "description": {
        "first": "La suppression de l’entreprise entraînera ",
        "second": "la suppression des offres et des employés",
        "third": " de l’entreprise. Voulez-vous supprimer toutes les données de l’entreprise de manière irréversible ?"
      },
      "buttons": {
        "confirm": "Oui, supprimer",
        "cancel": "Annuler"
      },
      "errorMessage": "Erreur lors de la suppression de l’entreprise"
    }
  },
  "user": {
    "title": "Utilisateurs",
    "create": {
      "title": "Créer un utilisateur"
    },
    "edit": {
      "personalData": "Fiche d’utilisateur",
      "updateError": "Erreur lors de la mise à jour des données",
      "updateSuccess": "Utilisateur mis à jour avec succès"
    }
  },
  "vacancy": {
    "error": "Erreur lors de la création de l’offre",
    "mainInfo": {
      "title": "Informations sur le poste"
    },
    "edit": {
      "saveError": "Impossible d’enregistrer l’offre",
      "workingConditions": {
        "title": "Conditions de travail",
        "requirements": "Exigences",
        "mandatoryRequirements": "Exigences du poste",
        "additionalRequirements": "Compétences appréciées",
        "additionalRequirementsDesc": "",
        "mandatoryRequirementsDesc": "",
        "responsibilities": {
          "title": "Responsabilités",
          "description": "",
          "subTitle": "Responsabilités du poste"
        },
        "typeEmployment": "Type d’emploi",
        "workingHours": "Horaires de travail",
        "lvlSalary": "Niveau de salaire",
        "suggestLvlSalary": "",
        "keySkills": "Compétences clés",
        "saveError": "Impossible d’enregistrer les conditions de travail"
      }
    },
    "actions": {
      "copy": "Bien reçu",
      "title": "Actions"
    }
  },
  "employee": {
    "edit": {
      "create": "Créer",
      "save": "Enregistrer"
    }
  },
  "buttons": {
    "askDelete": "Voulez-vous supprimer toutes les données de l’offre de manière irréversible ?",
    "confirmDelete": "Oui, supprimer",
    "deny": "Annuler",
    "back": "Retour",
    "save": "Enregistrer",
    "edit": "Modifier",
    "delete": "Supprimer"
  },
  "ui": {
    "selectDate": {
      "placeholder": "Sélectionnez une date"
    },
    "filters": {
      "subDescription": "Modifiez les filtres ou réinitialisez-les pour revenir à la liste complète.",
      "asc": "Croissant",
      "desc": "Décroissant",
      "clear": "Effacer",
      "search": "Rechercher",
      "vacancy": {
        "id": "ID de l’offre",
        "title": "Titre du poste",
        "manager": "Responsable de recrutement"
      },
      "name": {
        "placeholder": "Filtrer par prénom"
      },
      "date": {
        "asc": "Par date croissante",
        "desc": "Par date décroissante",
        "clear": "Effacer"
      },
      "title": "Filtres",
      "filtration": "Filtrage",
      "reset": "Réinitialiser",
      "apply": "Appliquer",
      "defaultPlaceHolder": "Sélectionnez des valeurs",
      "all": "Tous",
      "status": "Statut"
    },
    "modal": {
      "warning": "Un recruteur inactif n’a pas accès à la gestion des offres"
    },
    "dataTable": {
      "empty": {
        "description": "Aucun résultat trouvé"
      }
    }
  },
  "statusBadge": {
    "active": "Actif",
    "inactive": "Inactif"
  },
  "video": {
    "unmute": "Activer le son",
    "mute": "Couper le son"
  },
  "recruiter": "Recruteur",
  "manager": "manager",
  "registrationVerification": {
    "continue": "Continuer",
    "title": "Confirmez votre adresse email",
    "sentTo": "Nous avons envoyé un code à",
    "digitLabel": "Chiffre du code de confirmation",
    "confirm": "Confirmer",
    "back": "Modifier mes informations",
    "errors": {
      "required": "Champ obligatoire",
      "email": "Adresse email invalide",
      "terms": "Veuillez accepter les conditions.",
      "password_mismatch": "Les mots de passe ne correspondent pas",
      "password_length": "Le mot de passe doit contenir entre 8 et 64 caractères.",
      "invalid": "La valeur saisie est invalide.",
      "company_taken": "Une entreprise porte déjà ce nom. Choisissez un autre nom.",
      "validation_failed": "Vérifiez les champs indiqués.",
      "email_taken": "Un compte existe déjà avec cette adresse email. Connectez-vous.",
      "code_invalid": "Ce code est incorrect. Vérifiez les chiffres et réessayez.",
      "code_expired": "Ce code a expiré. Demandez un nouveau code.",
      "attempts_exhausted": "Vous avez atteint cinq tentatives incorrectes. Demandez un nouveau code.",
      "verification_required": "Demandez un nouveau code pour cette adresse email.",
      "verification_replaced": "Ce code a été remplacé. Utilisez le code du dernier email.",
      "verification_consumed": "Cette vérification a déjà été utilisée. Connectez-vous si votre compte existe.",
      "resend_too_soon": "Veuillez patienter avant de demander un nouveau code.",
      "send_limit_exceeded": "La limite d’envoi a été atteinte. Réessayez plus tard.",
      "request_limit_exceeded": "Trop de tentatives. Veuillez patienter avant de réessayer.",
      "mail_unavailable": "Le code n’a pas pu être envoyé. Réessayez dans un instant.",
      "verification_unavailable": "La vérification est indisponible. Réessayez dans un instant.",
      "technical": "Une erreur est survenue. Réessayez. Nous ne pouvons pas confirmer la création du compte.",
      "cooldown": "Un nouveau code pourra être envoyé dans {{seconds}} s."
    },
    "expires": "Le code expire dans {{minutes}} min {{seconds}} s.",
    "resend": "Renvoyer un code",
    "resendIn": "Renvoyer dans {{seconds}} s",
    "latestCode": "Après un nouvel envoi, utilisez uniquement le code du dernier email.",
    "automaticHint": "Le premier code complet sera vérifié automatiquement."
  }
}
